import { render, staticRenderFns } from "./SPRButton.vue?vue&type=template&id=364fa077&scoped=true"
import script from "./SPRButton.vue?vue&type=script&lang=ts"
export * from "./SPRButton.vue?vue&type=script&lang=ts"
import style0 from "./SPRButton.vue?vue&type=style&index=0&id=364fa077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364fa077",
  null
  
)

export default component.exports